module.exports = __webpack_public_path__ + "img/column_highlight.31a348d5.png";